import { Note } from '../../notes/notes.models';
import { AppState } from '../../reducers';

const notesSelector = (state: AppState) => state.redtail.notes;

export const redtailNoteSelector = (state: AppState): Note[] => notesSelector(state).notes;
